import { ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY } from "@/modules/atlas-auth/constants";
import { AtlasAuthInfo } from "@/modules/atlas-auth/types";
import localforage from "localforage";

export const setCurrentAtlasAuthInfo = async ({ info }: { info: AtlasAuthInfo }): Promise<void> => {
  await localforage.setItem(ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY, info);
};
